import { createReducer } from '@reduxjs/toolkit';
import { invalidateDiscountCode, resetDiscountCode, resetVoucherCode, setAllPrices, setAllPricesData, setIsDiscounted } from './action';
import type { PricesState } from './state';
import initialPricesState from './state';

export const pricesReducer = createReducer<PricesState>(initialPricesState, (builder) => {
    builder.addCase(setAllPrices, (state, { payload: { discount, shippingPrice, subTotal, total, voucher } }) => ({
        ...state,
        discount: {
            ...state.discount,
            value: discount,
        },
        shippingPrice: {
            ...state.shippingPrice,
            value: shippingPrice,
        },
        subTotal: {
            ...state.subTotal,
            value: subTotal,
        },
        total: {
            ...state.total,
            value: total,
        },
        voucher: {
            ...state.voucher,
            value: voucher,
        },
    }));

    builder.addCase(setAllPricesData, (state, {
        payload: {
            discount,
            discountCode,
            hasDiscount,
            shippingPrice,
            subTotal,
            total,
            voucher,
            voucherCode,
        },
    }) => ({
        ...state,
        discount,
        discountCode,
        hasDiscount,
        shippingPrice,
        subTotal,
        total,
        voucher,
        voucherCode,
    }));

    builder.addCase(setIsDiscounted, (state, { payload: { hasDiscount } }) => ({
        ...state,
        hasDiscount,
        isDiscountCodeValid: true,
    }));

    builder.addCase(resetDiscountCode, (state) => ({
        ...state,
        discount: {
            ...state.discount,
            value: 0,
        },
        discountCode: '',
        hasDiscount: false,
        isDiscountCodeValid: true,
    }));

    builder.addCase(resetVoucherCode, (state) => ({
        ...state,
        hasDiscount: false,
        isDiscountCodeValid: true,
        voucher: {
            ...state.voucher,
            value: 0,
        },
        voucherCode: '',
    }));

    builder.addCase(invalidateDiscountCode, (state) => ({
        ...state,
        hasDiscount: false,
        isDiscountCodeValid: false,
    }));
});
